// `0` works in mozilla and `32` in other browsers

$('.radio-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        $(this).find('input').prop('checked', true);
    }
});

$('.checkbox-label').keypress(function (e) {
    if (e.keyCode === 0 || e.keyCode === 32) {
        var $ele = $(this).find('input');
        $ele.prop('checked', !$ele.is(':checked'));
    }
});

$(document).on('click', '.js-toggle-side-menu', function (event) {
    event.preventDefault();

    var $sideMenu = $('.js-side-menu');
    if ($sideMenu.hasClass('open')) {
        $sideMenu.removeClass('open');
        $('.mobile-link').attr('tabindex', '-1').attr('aria-hidden', true);
    } else {
        $sideMenu.addClass('open');
        $('.js-toggle-side-menu').focus();
        $('.mobile-link').attr('tabindex', '0').attr('aria-hidden', false);
    }
});

$('.collapse').on('hide.bs.collapse', function () {
    $('.accordion-button-icon').removeClass('minus').addClass('plus');
}).on('show.bs.collapse', function () {
    $('.accordion-button-icon').removeClass('plus').addClass('minus');
});

$('.modal').on('show.bs.modal', function () {
    $('.modal .modal-body').css('overflow-y', 'auto');
    $('.modal .modal-body').css('max-height', $(window).height() * 0.7);
});

$(document).on('click', '.js-cookie-consent-agree', function (event) {
    event.preventDefault();

    $('.js-cookie-consent').fadeOut();
    Cookies.set('cookie-bar', 'true', {secure: false});
});

$('#scroll-up').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, '300');
});


$('.carousel').slick({
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ],
    prevArrow: $('.GTM-cta-button-arrow-left'),
    nextArrow: $('.GTM-cta-button-arrow-right'),
});


var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}

$('.js-toggle-menu').click(function (e) {
    e.preventDefault();
    $('.mobile-header-nav').slideToggle();
    $(this).toggleClass('open');
});

$(document).ready(function () {
    // errors block exists
    if ($('.form-group.has-error:first').length > 0) {
        // scroll to error
        $('html, body').animate({
            scrollTop: $('.form-group.has-error:first').offset().top
        }, 100);
    }
});


$('.btn-number').click(function (e) {
    e.preventDefault();

    fieldName = $(this).attr('data-field');
    type = $(this).attr('data-type');
    var input = $("input[name='" + fieldName + "']");

    var currentVal = parseInt(input.val());

    if (!isNaN(currentVal)) {
        if (type == 'minus') {

            if (currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            }
            if (parseInt(input.val()) == input.attr('min')) {
                $(this).attr('disabled', true);
            }

        } else if (type == 'plus') {

            if (currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if (parseInt(input.val()) == input.attr('max')) {
                $(this).attr('disabled', true);
            }

        }
    } else {
        input.val(0);
    }

});

$('.input-number').focusin(function () {
    $(this).data('oldValue', $(this).val());
});

$('.input-number').change(function () {

    minValue = parseInt($(this).attr('min'));
    maxValue = parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());

    name = $(this).attr('name');
    if (valueCurrent >= minValue) {
        $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    if (valueCurrent <= maxValue) {
        $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
    } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
    }

});


$(document).mouseup(function (e) {
    var basket = $("#basket-contents");
    // if the target of the click isn't the container nor a descendant of the container
    if (!basket.is(e.target) && basket.has(e.target).length === 0) {
        $('#overlay').hide();
        basket.slideUp(500);
    }
});

$(document).on('click', '.basket-toggle', function (event) {
    event.preventDefault();
    $('#overlay').toggle();
    $('#basket-contents').slideDown(500);
});
$(document).on('click', '#basket-close', function (event) {
    event.preventDefault();
    $('#overlay').hide();
    $('#basket-contents').slideUp(500);
});


var scrollDir = (function (oldOffset, lastOffset, oldDir) {
    return function (offset) {

        var dir = offset < oldOffset;
        if (dir !== oldDir) {
            lastOffset = offset;
        } else {
            offset = offset - height;
        }
        oldOffset = offset;
        oldDir = dir;
        return {
            dir: dir,
            last: lastOffset
        };
    };
}());


var header = document.querySelector('#header');
var height = header.clientHeight;

$(window).scroll(function () {

    if ($(window).scrollTop() > 50 && $(window).width() > 768) {
        $('#overlay').hide();
        $('#basket-contents').slideUp(500);
        $('#header').stop().animate({
            top: -height
        }, 10);
    }
    if ($(window).scrollTop() < 50) {
        $('#header').stop().animate({
            top: 0
        }, 10);
    }
});


$(document).ready(function () {

    if ($('#updateBasketRoute').length > 0) {

        $.ajax({
            method: 'GET',
            dataType: 'json',
            cache: false,
            url: $('#updateBasketRoute').val(),
            success: function (response) {

                if (response.items) {

                    $('.header-login .cta-button--primary.top').addClass('basket-toggle').html(response.totalQuantity + (response.totalQuantity == 0 || response.totalQuantity > 1 ? " Items " : " Item ") + '<i class="fa fa-shopping-cart"></i>');

                    $('#basket-contents .mp').html('<p>' + response.maxPoints + ' points to spend</p>');
                    $('#basket-contents .cart').html('<p>' + response.totalQuantity + (response.totalQuantity == 0 || response.totalQuantity > 1 ? " Items " : " Item ") + '<i class="fa fa-shopping-cart"></i>');
                    $('#basket-contents .qt').html('<p>' + response.totalQuantity + (response.totalQuantity == 0 || response.totalQuantity > 1 ? " Items " : " Item ") + 'in your basket</p>');
                    $('#basket-contents .pt').html('<p>' + response.totalPoints + ' Points</p>');

                    var itemHtml = '';

                    $.each(response.items, function (i, bItem) {
                        $.each(bItem, function (i, item) {
                            itemHtml += '<div class="item-holder pt-3"><div class="row"><div class="col-md-6"><img src="' + item.image + '" width="150"></div><div class="col-md-6"><h5>' + item.item.name + '</h5> <p class="points">' + item.points + ' Points</p><p class="quantity">Quantity: ' + item.quantity + '</p></div></div><div class="clearfix"></div></div>';
                        });
                    });

                    $('#basket-items').html(itemHtml);

                    itemHtml = '<div class="row"><div class="col-md-12 remaining"><p>Remaining: <span>' + (response.maxPoints - response.totalPoints) + ' points</span></p></div></div>';
                    $('#basket-bottom').html(itemHtml);
                }

            }
        });

    }

});

$(window).bind("pageshow", function (event) {
    if (event.originalEvent.persisted) {
        window.location.reload()
    }
});

// region Modal trap keyboard focus function
window.trapKeyboardFocus = function(selector_id) {
    const modal = document.querySelector(selector_id); // select the modal by it's id
    if (!modal) {
        console.error('Modal does not exist: ' + selector_id);
        return;
    }

    // add all the elements inside modal which you want to make focusable
    const focusableElements =
        '[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                console.log('shift');
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                console.log('tab');
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    });
}

// endregion

//my account
if ( document.location.href.indexOf('account/') > -1 ) {
    $('html, body').animate({ scrollTop: $('#main-content').offset().top }, 'slow');
}
